import { proxy } from 'valtio'

export interface IFindStatus {
    date: string
    msg: string
}

export const findState = proxy({
    inProgress: {} as Record<string, boolean>,
    status: {} as Record<string, IFindStatus>,
})

export function setFindInProgress(id: string, b: boolean) {
    findState.inProgress[id] = b
}

export function setFindStatus(petId: string, message: IFindStatus) {
    findState.status[petId] = message
}

export function resetFind() {
    findState.inProgress = {}
    findState.status = {}
}

export default findState
